import { rgba } from 'polished';
import styled, { DefaultTheme, css } from 'styled-components';

type CopyCodeProps = {
  variant: 'primary' | 'secondary';
};

const wrapperModifiers = (theme: DefaultTheme) => ({
  primary: css`
    border-radius: 16px;
    box-shadow: 0 8px 16px ${rgba(theme.colors.globalBlack100, 0.05)};
    padding: 12px;
    display: inline-flex;
    align-items: center;

    ${Code} {
      font-size: 3.6rem;
      font-weight: 600;
      color: ${theme.colors.brandPrimary70};
      margin-right: 20px;
    }

    ${Copy} {
      color: ${theme.colors.brandPrimary70};
    }
  `,
  secondary: css`
    border-radius: 12px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${theme.colors.neutralSilver10};
    gap: 8px;

    ${Code} {
      font-weight: 500;
      font-size: 2rem;
      line-height: 2.8rem;
      color: ${theme.colors.globalBlack};
    }

    ${Copy} {
      color: ${theme.colors.neutralSilver40};

      svg {
        stroke-width: 2px;
      }
    }
  `,
});

export const Wrapper = styled.div<CopyCodeProps>`
  ${({ theme, variant }) => css`
    background-color: ${theme.colors.globalWhite100};

    ${wrapperModifiers(theme)[variant]}
  `}
`;

export const Code = styled.span``;

export const Copy = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
